import { Flex } from 'antd';
import { PrimaryCard } from '../../assets/styles/components/dashboard.styled';
import { Divider, Paragraph } from '../Ant';
import { Calendar, TagUser } from '../icons';
import CardData from '../dashboard/cardData';
import { ICustomerIdentification } from '../../interface/identifications';
import {
  identificationBorderColors,
  identificationLevelTranslationMapping,
  identificationStatusColors,
  identificationStatusTranslationMapping,
} from '../../constants/identification';
import { useTranslation } from 'react-i18next';
import { getTranslationFromTranslatableEntity } from '../../constants/matter';
import { useLanguage } from '../../context/LanguageContext';
import dayjs from 'dayjs';

const IdentificationCard = ({ item }: { item: ICustomerIdentification }) => {
  const { t } = useTranslation();
  const { getAppLanguageCode } = useLanguage();

  return (
    <PrimaryCard
      data-testid="identification-card"
      className={`pointer w-full customer-card  ${identificationBorderColors[item?.status]}`}
    >
      <Flex justify="space-between" align="center" className="pb-10">
        <Flex gap={8} align="center">
          <Flex
            data-testid="identification-status-chip"
            justify="center"
            align="center"
            className={`status-chip ${identificationStatusColors[item?.status]}`}
          >
            {t(identificationStatusTranslationMapping[item?.status])}
          </Flex>
        </Flex>

        <Paragraph
          data-testid="identification-level"
          $weight={500}
          $lineheight="18px"
          $color="title"
          $fontsize="12px"
        >
          {t(identificationLevelTranslationMapping[item?.level])}
        </Paragraph>
      </Flex>
      <Divider className="mb-10" />
      <Flex vertical gap={10}>
        <CardData
          type="customer-identification"
          icon={<TagUser />}
          title={t('customerIdentification:identification')}
          content={item.company?.name ?? item.privatePerson?.fullName ?? '-'}
          subcontent={getTranslationFromTranslatableEntity(
            item?.riskAssessment?.translations,
            getAppLanguageCode(),
          )}
          contentclass="lineclamp-1"
        />
        <CardData
          type="review-date"
          icon={<Calendar />}
          title={t('customerIdentification:reviewedDate')}
          content={item?.reviewedOn ? dayjs(item?.reviewedOn).format('MMM DD, YYYY') : '-'}
        />
      </Flex>
    </PrimaryCard>
  );
};

export default IdentificationCard;
